import util from './util'

let Timeline = Vue.component('timeline', {
	data() {
		return {
			posts: [],
			ready: false,
			visibleStyle: {
				opacity: 0
			}
		}
	},
	methods: {
		onClick: util.onClickDefaultLink
	},
	mounted() {
		util.getTimeline().then((response) => {
			this.posts = orderBy(response, 'date', 'desc')
			this.$nextTick(() => {
				this.ready = true
			})
		}).catch((e) => {
			this.ready = true
			console.log(e)
		})
	},
	template: `
		<div>
			<transition-group name="fade" tag="ul" class="timeline">
				<li v-for="post in posts" :key="post.id">
					<colored-link type="timeline" :data-id="post.id" :href="post.link">
						<div class="timeline-date" v-html="post.date"></div>
						<div class="timeline-title" v-html="post.multi_line_title"></div>
					</colored-link>
				</li>
			</transition-group>
			<div class="ajax-pushfix" v-if="!ready"></div>
		</div>`
})

export default Timeline
